import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SummaryRankedListItemTranslation {
  language: { code: string; [key: string]: any };
  [key: string]: any;
}

export interface SummaryRankedListItem {
  label?: string;
  secondary?: string;
  translations?: SummaryRankedListItemTranslation[];
}

@Component({
  selector: 'mh-core-lib-summary-ranked-list-widget',
  templateUrl: './summary-ranked-list-widget.component.html',
  styleUrls: ['./summary-ranked-list-widget.component.scss'],
  standalone: false,
})
export class CoreLibSummaryRankedListWidgetComponent {
  @Input() title = '';
  @Input() items: SummaryRankedListItem[] = [];
  @Input() loading = false;
  @Input() height = '18rem';
  @Input() emptyMessage = '';
  @Input() actionText = '';
  @Input() currentLanguage: string | null = null;
  @Input() translationsValueKey = 'name';

  @Output() viewAll = new EventEmitter<void>();
}
